import analytics from 'common/analytics';
import { getNow } from 'application/util/time.util';
import { getErrorMessage } from 'application/util/error.util';

import './account.style.sass';
import template from './account.tpl.pug';

class AccountSettingsController {
    /* @ngInject */
    constructor($q, $state, sessionService, emailVerificationService, profileService, notificationService, modalService) {
        this.$q = $q;
        this.$state = $state;
        this.sessionService = sessionService;
        this.emailVerificationService = emailVerificationService;
        this.profileService = profileService;
        this.notificationService = notificationService;
        this.modalService = modalService;

        this.currentPassword = null;
        this.newPassword = null;
    }

    $onInit() {
        this.loading = true;

        return this.sessionService.reload().then((session) => {
            let { user } = session;

            this.name = user.name;
            this.email = user.email;
            this.originalEmail = this.email;
            this.expirationDate = user.verified
                ? null
                : user.expirationDate;
            this.expired = this.expirationDate && getNow() > this.expirationDate;

            // Check if restore action is requested via URL parameter
            if (this.$state.params.action === 'restore') {
                return this.$state.go('authorized.calendar.settings.data', {
                    action: 'restore'
                });
            }
        }).catch((result) => {
            this.notificationService.showError(getErrorMessage(result, `We were not able to retrieve your account settings.`));
        }).finally(() => {
            this.loading = false;
        });
    }

    get isEmailChanged() {
        return this.email !== this.originalEmail;
    }

    save(name, email, form) {
        if (this.isEmailChanged) {
            return this.modalService.open({
                component: 'dbAConfirmModal',
                bindings: {
                    title: 'Change email address',
                    message: [
                        `You are about to change current the email address (${this.originalEmail}) associated with this account to ${email}.`,
                        `An email will be sent to ${email} to confirm the request.`
                    ],
                    primaryButton: [
                        `Update`,
                        `Updating...`
                    ],
                    onClose: () => {
                        return this.update(name, email, form).then(() => {
                            this.email = this.originalEmail;
                            this.notificationService.showInfo(`An email has been sent to ${email} to confirm the email address change.`, null, true, 10000);
                        });
                    }
                }
            }).catch(() => null);
        }

        return this.update(name, email, form).then(() => {
            this.notificationService.showInfo(`Your name has been updated.`, null, true, 5000);
        }).catch(() => null);
    }

    update(name, email, form) {
        return this.profileService.save({
            name,
            email
        }).then(() => {
            form.$setPristine();
        }).catch((result) => {
            this.notificationService.showError(getErrorMessage(result, `We were not able to update your account information.`));
            return this.$q.reject(result);
        });
    }

    updatePassword(currentPassword, newPassword, form) {
        return this.profileService.updatePassword(currentPassword, newPassword).then(() => {
            form.$setPristine();

            this.currentPassword = null;
            this.newPassword = null;

            this.notificationService.showInfo(`You password has been updated.`);
            
            analytics.trackProfilePasswordChange();
        }, (result) => {
            this.notificationService.showError(getErrorMessage(result, `We were not able to update your password.`));
        });
    }

    sendVerificationEmail() {
        return this.emailVerificationService.send(this.email).then(() => {
            this.confirmationEmailSent = true;

            this.notificationService.showInfo(`The email has been sent to your inbox.`, null, true, 3000);
        }).catch((result) => {
            this.notificationService.showError(getErrorMessage(result, `We were not able to send you the account activation email. Please try again later.`));
        });
    }

    deleteAccount() {
        this.sessionService.deleteAccount()
            .then(() => {
                this.$state.go('identity.sign-in');
                this.notificationService.showInfo(`Your account and data has been deleted.`, null, true, 3000);
            })
            .catch(
                () => {
                    this.notificationService.showError(`We were not able to delete your account. Please try again later.`);
                }
            );
    }
}

export default {
    selector: 'dbAAccountSettings',
    template: template(),
    controller: AccountSettingsController,
    bindings: {
        plan: '<'
    }
};



// WEBPACK FOOTER //
// ./src/application/scene/authorized/scene/settings/scene/account/account.cmpt.js